"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const webapi_1 = require("@fegobull/webapi");
const vue_demi_1 = require("vue-demi");
const i18n_1 = tslib_1.__importDefault(require("../../i18n"));
const common_1 = require("../assets/scripts/common");
const formCache_1 = require("../assets/scripts/formCache");
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const utils_1 = require("../common/utils");
const fego_1 = require("../config/fego");
const ReservationForm_vue_1 = tslib_1.__importDefault(require("./components/ReservationForm.vue"));
const ReservationResult_vue_1 = tslib_1.__importDefault(require("./components/ReservationResult.vue"));
const __sfc_main = {};
__sfc_main.props = ['module_name', 'reserve_more_image', 'activity_key_list'];
__sfc_main.setup = (__props, __ctx) => {
    const { store: { variable } } = require('@futuweb/fego-render');
    const props = __props;
    // 定义事件
    const emits = __ctx.emit;
    /**
     * 更新 FEGO 变量
     * @param key 变量名
     * @param value 变量值
     */
    const updateFegoVariable = (key, value) => {
        variable.data[key] = value;
    };
    // 表单组件引用
    const reservationFormRef = (0, vue_demi_1.ref)(null);
    // 获取用户登录状态
    const { useUser } = webapi_1.use;
    const getUserInfo = () => {
        try {
            const { uid, isLogin } = useUser();
            return {
                uid,
                isLogin
            };
        }
        catch (e) {
            return {
                uid: 0,
                isLogin: false
            };
        }
    };
    // 模块名称（用于模板显示）
    const moduleName = (0, vue_demi_1.computed)(() => props.module_name);
    /**
     * 解析 activity_key_list 配置，将逗号分隔的字符串转为数组
     * @returns 活动 key 数组，未配置时返回空数组
     */
    const parseActivityKeyList = () => {
        const raw = props.activity_key_list;
        if (!raw || typeof raw !== 'string') {
            return [];
        }
        return raw.split(',').map((key) => key.trim()).filter((key) => key.length > 0);
    };
    // 加载状态：是否正在加载中
    const isLoading = (0, vue_demi_1.ref)(true);
    // 是否有错误
    const hasError = (0, vue_demi_1.ref)(false);
    // 错误消息
    const errorMessage = (0, vue_demi_1.ref)('');
    // 配置数据加载状态
    const configLoaded = (0, vue_demi_1.ref)(false);
    // 预约记录加载状态
    const reservationsLoaded = (0, vue_demi_1.ref)(false);
    // 配置数据
    const configData = (0, vue_demi_1.ref)(null);
    // 预约记录列表（包含后端计算的增强字段）
    const reservationList = (0, vue_demi_1.ref)([]);
    // 是否展示预约结果（用于手动切换）
    const showResult = (0, vue_demi_1.ref)(true);
    // Swiper 初始定位索引（创建预约后定位到新记录）
    const initialSlideIndex = (0, vue_demi_1.ref)(0);
    // 是否有表单项目
    const hasFormItems = (0, vue_demi_1.computed)(() => {
        var _a;
        const formConfig = ((_a = configData.value) === null || _a === void 0 ? void 0 : _a.formConfig) || [];
        return formConfig && formConfig.length > 0;
    });
    // 是否有可预约的时段（用于控制探索更多模块的显示）
    const hasAvailableTimeSlot = (0, vue_demi_1.computed)(() => {
        return checkHasAvailableTimeSlot();
    });
    // 是否应该隐藏容器（在加载完成、当前是表单页面、且没有表单项目时隐藏）
    const shouldHideWrapper = (0, vue_demi_1.computed)(() => {
        // 加载中或错误状态时，不隐藏
        if (isLoading.value || hasError.value) {
            return false;
        }
        // 如果没有配置数据，不隐藏（可能还在加载中）
        if (!configData.value) {
            return false;
        }
        // 如果当前是预约记录展示页面，不隐藏
        if (showResult.value && reservationList.value.length > 0) {
            return false;
        }
        // 当前是表单页面 && 没有表单项目，则隐藏
        return !hasFormItems.value;
    });
    /**
     * 检查指定时段是否已被用户预约（且未取消）
     */
    const isTimeSlotReserved = (activityKey, date, rangeKey) => {
        if (!reservationList.value || reservationList.value.length === 0) {
            return false;
        }
        return reservationList.value.some((record) => {
            // 匹配 activityKey + date + rangeKey
            const isMatch = record.activity_key === activityKey && record.date === date && record.range_key === rangeKey;
            // 未取消：canceled_at 为 0 或 null/undefined
            const isNotCanceled = !record.canceled_at || record.canceled_at === 0;
            return isMatch && isNotCanceled;
        });
    };
    /**
     * 检查是否有可预约的时段
     * 遍历所有活动的所有日期的所有时段，排除已满、已过期、已预约的时段
     * @returns 是否存在可预约的时段
     */
    const checkHasAvailableTimeSlot = () => {
        var _a;
        if (!((_a = configData.value) === null || _a === void 0 ? void 0 : _a.list)) {
            return false;
        }
        // 遍历所有活动
        for (const activity of configData.value.list) {
            if (!activity.availableDates) {
                continue;
            }
            // 遍历所有可用日期
            for (const dateSlot of activity.availableDates) {
                if (!dateSlot.timeRanges) {
                    continue;
                }
                // 遍历所有时段
                for (const timeSlot of dateSlot.timeRanges) {
                    // 判断是否禁用：已满或已过期
                    const isFullOrExpired = timeSlot.status === 'full' || timeSlot.status === 'expired';
                    if (isFullOrExpired) {
                        continue;
                    }
                    // 判断是否已被预约
                    const isReserved = isTimeSlotReserved(activity.activityKey, dateSlot.date, timeSlot.rangeKey);
                    if (isReserved) {
                        continue;
                    }
                    // 找到一个可预约的时段
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * 更新 FEGO 变量：是否有预约记录、是否有可预约的时段
     */
    const updateFegoVariables = () => {
        // 更新是否有预约记录
        // 排除已取消的记录
        const activeReservations = reservationList.value.filter(record => !record.canceled_at || record.canceled_at === 0);
        const hasReservationRecord = activeReservations.length > 0 ? 1 : 0;
        updateFegoVariable(fego_1.FEGO_VARIABLES.hasReservationRecord, hasReservationRecord);
        // 更新是否有可预约的时段
        const hasAvailableTimeSlot = checkHasAvailableTimeSlot() ? 1 : 0;
        updateFegoVariable(fego_1.FEGO_VARIABLES.hasAvailableTimeSlot, hasAvailableTimeSlot);
        console.log('[common-reservation] 更新 FEGO 变量:', {
            hasReservationRecord,
            hasAvailableTimeSlot
        });
    };
    /**
     * 检查并更新加载状态
     * 如果是登录态，需要配置和预约记录都加载完成才算完成
     * 如果是非登录态，只需要配置加载完成
     */
    const checkLoadingComplete = () => {
        const { isLogin } = getUserInfo();
        if (isLogin) {
            // 登录态：需要配置和预约记录都加载完成
            if (configLoaded.value && reservationsLoaded.value) {
                isLoading.value = false;
                // 数据加载完成后更新 FEGO 变量
                updateFegoVariables();
            }
        }
        else {
            // 非登录态：只需要配置加载完成
            if (configLoaded.value) {
                isLoading.value = false;
                // 非登录态也更新变量（此时没有预约记录，但可能有可预约的时段）
                updateFegoVariables();
            }
        }
    };
    /**
     * 获取配置信息
     */
    const fetchConfigInfo = async () => {
        const moduleName = props.module_name;
        if (!moduleName) {
            hasError.value = true;
            errorMessage.value = (0, i18n_1.default)('notConfigured');
            isLoading.value = false;
            return;
        }
        try {
            const data = await request_1.default.getConfigInfo({
                moduleName
            });
            // 根据 activity_key_list 过滤活动列表
            const activityKeyList = parseActivityKeyList();
            if (activityKeyList.length > 0 && data.list) {
                data.list = data.list.filter(item => activityKeyList.includes(item.activityKey));
                console.log('[common-reservation] 已按 activity_key_list 过滤配置列表:', activityKeyList);
            }
            configData.value = data;
            configLoaded.value = true;
            console.log('[common-reservation] getConfigInfo 响应:', data);
            // 检查是否加载完成
            checkLoadingComplete();
        }
        catch (error) {
            hasError.value = true;
            errorMessage.value = (0, i18n_1.default)('loadFailed');
            isLoading.value = false;
            console.error('[common-reservation] getConfigInfo 错误:', error);
        }
    };
    /**
     * 获取用户预约记录
     * @param updateLoadingState 是否更新加载状态，默认为 true
     */
    const fetchUserReservations = async (updateLoadingState = true) => {
        const { uid, isLogin } = getUserInfo();
        if (!uid || !isLogin) {
            console.log('[common-reservation] 用户未登录，跳过获取预约记录');
            // 非登录态时，标记预约记录已"加载完成"（无需加载）
            if (updateLoadingState) {
                reservationsLoaded.value = true;
                checkLoadingComplete();
            }
            return;
        }
        const moduleName = props.module_name;
        if (!moduleName) {
            return;
        }
        try {
            const data = await request_1.default.getUserReservationList({
                moduleName
            });
            console.log('[common-reservation] getUserReservationList 响应:', data);
            if (data === null || data === void 0 ? void 0 : data.list) {
                let list = data.list;
                // 根据 activity_key_list 过滤预约记录
                const activityKeyList = parseActivityKeyList();
                if (activityKeyList.length > 0) {
                    list = list.filter(item => activityKeyList.includes(item.activity_key || ''));
                    console.log('[common-reservation] 已按 activity_key_list 过滤预约记录:', activityKeyList);
                }
                reservationList.value = (0, utils_1.sortReservationList)(list);
            }
            // 标记预约记录加载完成
            if (updateLoadingState) {
                reservationsLoaded.value = true;
                checkLoadingComplete();
            }
        }
        catch (error) {
            console.error('[common-reservation] getUserReservationList 错误:', error);
            // 即使出错也标记为加载完成，避免一直卡在加载状态
            if (updateLoadingState) {
                reservationsLoaded.value = true;
                checkLoadingComplete();
            }
        }
    };
    /**
     * 在预约记录列表中查找匹配的记录索引
     * @param activityKey 活动标识
     * @param date 日期
     * @param rangeKey 时段标识
     * @returns 记录在列表中的索引，未找到返回 -1
     */
    const findRecordIndex = (activityKey, date, rangeKey) => {
        return reservationList.value.findIndex(record => {
            return record.activity_key === activityKey && record.date === date && record.range_key === rangeKey && (
            // 排除已取消的记录
            !record.canceled_at || record.canceled_at === 0);
        });
    };
    /**
     * 处理表单提交成功
     */
    const handleFormSubmit = async (submitData) => {
        console.log('[common-reservation] 表单提交数据:', submitData);
        // 检查用户是否登录
        const { isLogin } = getUserInfo();
        if (!isLogin) {
            console.log('[common-reservation] 用户未登录，保存表单数据到本地并跳转登录');
            // 保存表单数据到 localStorage
            const formDraft = {
                activityKey: submitData.activityKey || '',
                date: submitData.date || '',
                rangeKey: submitData.rangeKey || '',
                ext1: submitData.ext1 || null,
                ext2: submitData.ext2 || null
            };
            (0, formCache_1.saveFormDraft)(props.module_name, formDraft);
            // 跳转到登录页面
            (0, common_1.jumpLogin)();
            return;
        }
        try {
            // 调用创建预约接口
            await request_1.default.createReservation(submitData);
            console.log('[common-reservation] 创建预约成功');
            // 清除可能存在的表单草稿
            (0, formCache_1.clearFormDraft)(props.module_name);
            // 重新获取预约记录（不更新加载状态）
            await fetchUserReservations(false);
            // 更新 FEGO 变量（预约成功后，hasReservationRecord 需要更新为 true）
            updateFegoVariables();
            // 抛出预约成功事件
            emits(fego_1.EVENT_NAME_MAP.reservationSuccess);
            console.log('[common-reservation] 已抛出预约成功事件');
            // 等待 DOM 更新，确保 reservationList 已经更新
            await (0, vue_demi_1.nextTick)();
            // 计算新创建记录在列表中的索引，用于 Swiper 定位
            const newRecordIndex = findRecordIndex(submitData.activityKey, submitData.date, submitData.rangeKey);
            initialSlideIndex.value = newRecordIndex >= 0 ? newRecordIndex : 0;
            console.log('[common-reservation] 新记录索引:', initialSlideIndex.value);
            console.log('reservationList.value.length', reservationList.value.length);
            // 切换到预约结果展示（确保有预约记录时才切换）
            if (reservationList.value.length > 0) {
                showResult.value = true;
            }
        }
        catch (error) {
            console.error('[common-reservation] 创建预约失败:', error);
        }
    };
    /**
     * 处理预约更多（切换回表单）
     */
    const handleReserveMore = () => {
        console.log('[common-reservation] 预约更多');
        showResult.value = false;
    };
    /**
     * 处理查看预约记录（从表单切换到预约记录）
     */
    const handleViewRecords = () => {
        console.log('[common-reservation] 查看预约记录');
        showResult.value = true;
    };
    /**
     * 处理邀请好友（点击喊朋友一起去）
     */
    const handleInvite = (record) => {
        console.log('[common-reservation] 邀请好友:', record);
        // 抛出点击喊朋友一起去事件
        emits(fego_1.EVENT_NAME_MAP.clickInviteFriends);
        console.log('[common-reservation] 已抛出点击喊朋友一起去事件');
    };
    /**
     * 处理取消预约成功
     * 直接在本地更新预约记录状态，不重新请求
     */
    const handleCanceled = async (record) => {
        console.log('[common-reservation] 取消预约成功:', record);
        // 直接在本地更新对应记录的状态字段
        const targetRecord = reservationList.value.find(item => item.id === record.id);
        if (targetRecord) {
            const nowUnix = Math.floor(Date.now() / 1000);
            targetRecord.canceled_at = nowUnix;
            // 同时更新 displayStatus 和 canCancel，因为 ReservationResult 优先使用这些字段判断状态
            targetRecord.displayStatus = 'canceled';
            targetRecord.canCancel = false;
        }
        // 检查是否还有有效预约记录（排除已取消的记录）
        const activeReservations = reservationList.value.filter(item => !item.canceled_at || item.canceled_at === 0);
        // 如果没有有效预约记录，刷新页面（同 hasReservationRecord 逻辑）
        if (activeReservations.length === 0) {
            console.log('[common-reservation] 取消预约后没有有效预约记录，刷新页面');
            window.location.reload();
            return;
        }
    };
    /**
     * 处理签到成功
     */
    const handleSigned = async (record) => {
        console.log('[common-reservation] 签到成功:', record);
        // 重新获取预约记录（不更新加载状态）
        await fetchUserReservations(false);
    };
    /**
     * 尝试从 localStorage 恢复表单草稿数据
     */
    const tryRestoreFormDraft = async () => {
        var _a;
        console.log('[common-reservation] 尝试恢复表单草稿');
        const { isLogin } = getUserInfo();
        if (!isLogin) {
            console.log('[common-reservation] 用户未登录，跳过恢复表单草稿');
            // return;
        }
        const moduleName = props.module_name;
        if (!moduleName) {
            return;
        }
        // 加载表单草稿
        const formDraft = (0, formCache_1.loadFormDraft)(moduleName);
        if (!formDraft) {
            return;
        }
        // 如果存在草稿数据，强制切换到表单视图
        // 这样即使用户有预约记录，也能看到表单并恢复草稿
        showResult.value = false;
        // 等待组件渲染完成（ReservationForm 需要在 DOM 中渲染）
        await (0, vue_demi_1.nextTick)();
        // 恢复表单数据
        if ((_a = reservationFormRef.value) === null || _a === void 0 ? void 0 : _a.setFormData) {
            reservationFormRef.value.setFormData(formDraft);
            console.log('[common-reservation] 已恢复表单草稿数据');
            // 清除已恢复的草稿（避免重复恢复）
            (0, formCache_1.clearFormDraft)(moduleName);
        }
    };
    /**
     * 执行预约行为方法（供 FEGO 调用）
     * 使用当前表单选中的数据执行预约
     */
    const doReservation = async () => {
        console.log('[common-reservation] 执行预约行为方法');
        // 如果当前不是表单模式，先切换到表单模式
        if (showResult.value) {
            console.log('[common-reservation] 当前是预约记录模式，切换到表单模式');
            showResult.value = false;
            // 等待组件渲染完成
            await (0, vue_demi_1.nextTick)();
        }
        // 检查表单组件是否存在，如果不存在则等待一段时间后重试
        if (!reservationFormRef.value) {
            console.log('[common-reservation] 表单组件未找到，等待渲染...');
            // 等待组件渲染完成，最多等待 3 次
            for (let i = 0; i < 3; i++) {
                await (0, vue_demi_1.nextTick)();
                if (reservationFormRef.value) {
                    break;
                }
            }
            // 如果仍然不存在，报错返回
            if (!reservationFormRef.value) {
                console.error('[common-reservation] 表单组件未找到，无法执行预约');
                return;
            }
        }
        // 先尝试自动选中唯一选项（如果只有一个可选的时段，自动选中）
        // 可能需要多次调用，因为选中活动后日期选项才会更新，选中日期后时段选项才会更新
        if (reservationFormRef.value.autoSelectSingleOptions) {
            console.log('[common-reservation] 尝试自动选中唯一选项');
            // 最多尝试 3 次，确保所有选项都被选中
            for (let i = 0; i < 3; i++) {
                reservationFormRef.value.autoSelectSingleOptions();
                await (0, vue_demi_1.nextTick)();
                // 检查是否已经选中了所有必填字段
                const formData = reservationFormRef.value.getFormData();
                if ((formData === null || formData === void 0 ? void 0 : formData.activityKey) && formData.date && formData.rangeKey) {
                    console.log('[common-reservation] 自动选中完成');
                    break;
                }
            }
        }
        // 获取表单数据
        const formData = reservationFormRef.value.getFormData();
        if (!formData) {
            console.error('[common-reservation] 无法获取表单数据');
            return;
        }
        // 校验必填字段
        if (!formData.activityKey || !formData.date || !formData.rangeKey) {
            console.error('[common-reservation] 表单数据不完整:', formData);
            return;
        }
        // 构造提交数据
        const submitData = {
            moduleName: props.module_name,
            activityKey: formData.activityKey,
            date: formData.date,
            rangeKey: formData.rangeKey,
            ext1: formData.ext1 && (Array.isArray(formData.ext1) ? formData.ext1.join(',') : formData.ext1) || undefined,
            ext2: formData.ext2 && (Array.isArray(formData.ext2) ? formData.ext2.join(',') : formData.ext2) || undefined
        };
        // 调用表单提交处理
        await handleFormSubmit(submitData);
        window.location.reload();
    };
    (0, vue_demi_1.onMounted)(async () => {
        console.log('[common-reservation] 组件已挂载，moduleName:', props.module_name);
        // 初始化 FEGO 变量为 0
        updateFegoVariable(fego_1.FEGO_VARIABLES.hasReservationRecord, 0);
        updateFegoVariable(fego_1.FEGO_VARIABLES.hasAvailableTimeSlot, 0);
        console.log('[common-reservation] 更新 FEGO 变量:', {
            hasReservationRecord: 0,
            hasAvailableTimeSlot: 0
        });
        // 先获取配置信息
        await fetchConfigInfo();
        // 再获取用户预约记录
        await fetchUserReservations();
        // 尝试恢复表单草稿（在配置加载完成后）
        await tryRestoreFormDraft();
    });
    // 暴露方法给 FEGO 调用
    return Object.assign({
        $t: i18n_1.default,
        props,
        reservationFormRef,
        moduleName,
        isLoading,
        hasError,
        errorMessage,
        configData,
        reservationList,
        showResult,
        initialSlideIndex,
        hasAvailableTimeSlot,
        shouldHideWrapper,
        handleFormSubmit,
        handleReserveMore,
        handleViewRecords,
        handleInvite,
        handleCanceled,
        handleSigned
    }, {
        doReservation
    });
};
__sfc_main.components = Object.assign({
    ReservationResult: ReservationResult_vue_1.default,
    ReservationForm: ReservationForm_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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